<ng-container *ngIf="showBackButton$ | async">
  <button type="button" class="btn p-1" (click)="goBack()">
    <i class="fa fa-fw fa-arrow-left"></i>
  </button>
</ng-container>